<template>
  <v-container fluid fill-height>
    <v-layout v-if="parte == 'inicial'" text-center wrap align-center justify-center>
      <v-flex xs12>
        <h1 class="display-1 my-5">
          <span class="font-weight-bold">Criadores</span>
          | Nova Música Gospel
        </h1>
        <p class="subheading font-weight-regular">Crie uma conta ou acesse a sua.</p>
        <div class="py-5">
          <v-btn :to="{name:'cadastro'}" class="mx-5 my-5" outlined color="primary" text>Criar Conta</v-btn>
          <v-btn @click="login()" class="mx-5 my-5 elevation-0" color="primary" text>Entrar</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    parte: "inicial"
  }),
  methods: {
    create_acount() {},
    login() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
